<template>
  <PageContainer id="miranda-page">
    <div class="page-content">
      <div class="title">Don't take our word for it...</div>

      <img :src="mirandaImg" alt="A HealthyWager participant">
      <p>“The money is a motivator, it really is... I had tried so many times to lose weight and failed.”</p>
    </div>

    <div class="footer-container">
      <ButtonNext :onClick="next" :isDisabled="false" :text="'Continue'" />
      <ProgressBar />
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '../../shared/components/PageContainer';
import ButtonNext from '../../shared/components/ButtonNext';
import ProgressBar from '../../shared/components/ProgressBar';
import { STATIC_URL } from '../main';
import Trackeable from '../../Trackeable';
import ProgressFull from '../mixins/ProgressFull';
import { navigateTo, ROUTE_NAMES } from '../router';

export default {
  components: {
    PageContainer,
    ButtonNext,
    ProgressBar
  },
  mixins: [Trackeable, ProgressFull],
  data() {
    return {
      mirandaImg: `${STATIC_URL}img/spa/miranda.png`
    }
  },
  methods: {
    next() {
      navigateTo(this.$router, ROUTE_NAMES.PastChallenges)
    }
  }
}
</script>
